import { render, staticRenderFns } from "./deviantDialog.vue?vue&type=template&id=f07b6840&scoped=true&"
import script from "./deviantDialog.vue?vue&type=script&lang=js&"
export * from "./deviantDialog.vue?vue&type=script&lang=js&"
import style0 from "./deviantDialog.vue?vue&type=style&index=0&id=f07b6840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07b6840",
  null
  
)

export default component.exports